import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { BottomSheet } from "react-spring-bottom-sheet";
import comment from "../assets/comment.png";
import like from "../assets/like.png";
import play from "../assets/play.svg";
import { useParams } from "react-router";
import { VIDEO_DETAILS } from "../constants/urls";
import ProfileDownloadIcon from "../components/mobile/ProfileDownloadIcon";
import FollowButtonProfilePic from "../components/mobile/FollowButtonProfilePic";
import Navbar from "../components/desktop/Navbar";
import VideoCard from "../components/desktop/VideoCard";
import BlueSticker from "../components/desktop/BlueSticker";
import DownloadBottomSheet from "../components/mobile/DownloadBottomSheet";
import { Swiper, SwiperSlide } from "swiper/react";
import "react-spring-bottom-sheet/dist/style.css";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { Pagination } from "swiper/core";
import Modal from "react-modal";
import BlueButton from "../components/desktop/BlueButton";

// install Swiper modules
SwiperCore.use([Pagination]);

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
`;

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
`;

const VideoDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 16px;
`;

const VideoDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  max-width: 60%;
`;

const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  z-index: 1;
`;

const UserName = styled.div`
  font-size: 20px;
  font-weight: 600;
  font-family: "Poppins";
  padding-bottom: 8px;
  z-index: 1;
`;

const Caption = styled.div`
  font-weight: 500;
  font-size: 16px;
  font-family: "Inter";
`;

const BlueBanner = styled.a`
  background: linear-gradient(254.06deg, #59c5e8 -33.43%, #5a8ef1 113.89%);
  font-family: "Inter";
  padding: 10px 16px;
  margin: 16px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

const VideoHolder = styled.video`
  transform: scale(2.5);
  display: flex;
  height: 50vh;
`;

const Container = styled.div`
  padding: 12px 120px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100vh;
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(21, 21, 29, 1)",
    borderWidth: 0,
    padding: "62px 62px",
    height: "214px",
    width: "340px",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
    alignItems: "center",
  },
};

const CtaButton = ({ count, img }) => {
  return (
    <a
      onClick={() => {
        setOpen(true);
        console.log(open);
        window.analytics.track('modal_open_cta_clicked', {
          icon: `${img}`,
        })
        
      }}
      style={{ textAlign: "center" }}
    >
      <img src={img} />
      <div style={{ textAlign: "center", marginBottom: 16 }}>{count}</div>
    </a>
  );
};

export default function VideoPage(props) {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [data, dataSet] = useState();
  const [videos, videosSet] = useState([]);
  const [video, videoSet] = useState([]);
  const [users, usersSet] = useState({});
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const { videoId } = useParams();

  useEffect(() => {
    async function fetchMyAPI() {
      let response = await fetch(VIDEO_DETAILS + videoId);
      response = await response.json();
      console.log(response);

      const videos = [];
      videos.push(response.data.video);
      response.data.otherVideos.map((item) => videos.push(item));
      videosSet(videos);
      usersSet(response.data.users);
      videoSet(response.data.video);
      dataSet(response.data);
    }

    fetchMyAPI();
  }, []);

  useEffect(() => {
    if (data) {
      var vid = document.getElementsByClassName(`video-0`)[0];
      vid.play();
    }
  }, [data]);

  if (!data) {
    return <></>;
  }

  const list = videos.map((item, index) => {
    var pause = true;
    if (index == activeIndex) pause = false;
    return (
      <SwiperSlide key={index}>
        <VideoContainer>
          <div style={{display: 'flex'}} className={`video-container-${index}`}>
          <img
            style={{
              zIndex: 10,
              width: 40,
              height: 40,
              alignSelf: "center",
              top: 240,
              position: "relative",
              left: '43%',
              pointerEvents: 'none'
            }}
            className={'mobile-play-icon'}
            src={play}
            // onClick=
          />
          </div>
          <VideoHolder
            className={`video-player-mobile video-${index}`}
            onClick={(e) => {e.target.play();document.getElementsByClassName('mobile-play-icon')[0].style.display = 'none'}}
            src={item.videoUri}
            autoPlay={false}
            paused={pause}
            loop={true}
            // muted
            // controls
          />
          <div>
            <VideoDetails>
              <VideoDetailsSection>
                <UserName>@{users[item.user].username}</UserName>
                <Caption>{item.caption}</Caption>
              </VideoDetailsSection>
              <CTASection>
                <div
                  style={{ display: "contents" }}
                  onClick={() => { 
                    setOpen(true);
                    window.analytics.track('modal_open_cta_clicked', {
                    })

                  }}
                >
                  <FollowButtonProfilePic img={users[item.user].pictureUri} />
                </div>
                <CtaButton img={like} count={item.likes} />
                <CtaButton img={comment} count={item.comments} />
              </CTASection>
            </VideoDetails>
            <BlueBanner
              href={
                "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"
              }
            >
              <div>
                <span>Explore more clips by @{users[item.user].username}</span>{" "}
                <br></br>
                <span style={{ opacity: 0.7, fontSize: 12 }}>
                  Download app now
                </span>
              </div>
              <ProfileDownloadIcon
                img={users[item.user].pictureUri}
              ></ProfileDownloadIcon>
            </BlueBanner>
          </div>
        </VideoContainer>
      </SwiperSlide>
    );
  });

  const desktop_list = videos.map((item, index) => {
    return (
      <VideoCard
        key={index}
        openModal={openModal}
        video={item}
        user={users[item.user]}
      />
    );
  });

  return (
    <>      
      <Mobile>
        <Swiper
          direction={"vertical"}
          pagination={{
            clickable: true,
          }}
          className="mySwiper"
          onSlideChange={({ realIndex }) => {
            if (realIndex == 3) setOpen(true);
            setActiveIndex(realIndex);
            document.getElementsByClassName('mobile-play-icon')[0].style.display = 'none'
            var vids = document.getElementsByClassName("video-player-mobile");
            for (const v in vids) {
              if (v == "length") break;
              vids[v].pause();
            }
            var vid = document.getElementsByClassName(`video-${realIndex}`)[0];
            vid.play();
          }}
          style={{ height: "100%" }}
        >
          {list}
        </Swiper>
        <BottomSheet
          onDismiss={() => setOpen(false)}
          snapPoints={({ maxHeight }) => [400]}
          open={open}
        >
          {video.user && (
            <DownloadBottomSheet img={users[video.user].pictureUri} />
          )}
        </BottomSheet>
      </Mobile>
      <Desktop>
        <Navbar />
        <Container>
          <div style={{ marginRight: 40, display: "flex", flex: 1 }}>
            <BlueSticker video={video} user={users[video.user]} />
          </div>
          <div
            className={"desktop-item-list"}
            style={{
              display: "flex",
              flex: 2,
              flexDirection: "column",
              overflow: "scroll",
            }}
          >
            {desktop_list}
          </div>
        </Container>

        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <ProfileDownloadIcon img={users[video.user].pictureUri} />
          <span style={{ textAlign: "center" }}>
            Sign up and throw likes <br></br> at @{users[video.user].username}
          </span>
          <span
            style={{
              textAlign: "center",
              marginTop: 4,
              opacity: 0.7,
              fontSize: 12,
            }}
          >
            Join ggTV community to browse,<br></br> create & share gaming clips
          </span>
          <br></br>
          <BlueButton
            href={
              "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"
            }
          >
            Download android app now
          </BlueButton>
        </Modal>
      </Desktop>
    </>
  );
}

// module.exports = VideoPage;
